<template>
  <div
    :class="{
      'w-16 flex items-center': !$layout.stickyNavOpen,
      'w-64 2xl:w-80': $layout.stickyNavOpen,
    }"
    class="flex flex-col pl-6 pr-4 group/theme-[:not(.theme-light)]:border-r-2 group/theme-[:not(.theme-light)]:border-ocean-100 transition-transform"
  >
    <transition
      name="fade"
      appear
    >
      <vetster-dynamic-sticky-nav
        :append-id="appendId"
        :categories="categories"
        position="side"
        title-key="nav_title"
      />
    </transition>
  </div>
</template>

<script>
import VetsterDynamicStickyNav from '@/components/VetsterDynamicStickyNav';

export default {
  name: 'VetsterLeftStickyCollapsableContent',

  components: { VetsterDynamicStickyNav },

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    post: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    appendId() {
      return this.post?.id ? `-${this.post.id}` : '';
    },
  },
};
</script>
